import React from 'react';
import { CTAButton } from './CTAButton';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR, PRODUCT_IMG } from './constants';
export function Hero() {
  return <section className="border-b border-sage/30 bg-cream px-4 pb-8 pt-5 sm:pt-7" data-id="element-85" data-mp="9ktcvkgndww6">
      <div className="mx-auto max-w-3xl text-center" data-id="element-86" data-mp="9ipcvdlvdi16">
        <p className="font-display text-[11px] font-bold uppercase tracking-[0.14em] text-sage sm:text-xs" data-id="element-87" data-mp="4mrvd3yve5mt">
          🗣️ Logopedia Pro™ — Sistema Professionale Completo 6-in-1
        </p>
        <h1 className="mt-2 font-display text-[26px] font-black leading-[1.05] sm:text-4xl lg:text-[42px]" data-id="element-88" data-mp="xa4gd9pdu5e0">
          Il Sistema Completo di Pianificazione e Materiali per Logopedisti
        </h1>
        <p className="mx-auto mt-3 max-w-2xl text-[15px] leading-snug text-graphite sm:text-lg" data-id="element-89" data-mp="nczs94bz7zuk">
          Risparmia ore ogni settimana nella preparazione di sessioni, attività, obiettivi, percorsi
          terapeutici e materiali professionali, senza dover creare tutto da zero per ogni paziente.
        </p>

        <a href={OFFER_ANCHOR} className="mt-4 block" aria-label="Vai all'offerta" data-id="element-90" data-mp="3j9kbrdwi3lh6">
          <img src={PRODUCT_IMG} alt="LOGOPEDIA PRO™: 6 moduli professionali e 5 bonus su computer, tablet e smartphone" className="mx-auto w-full max-w-xl transition-transform duration-200 ease-out hover:scale-[1.01]" data-id="element-91" data-mp="3o7vk1k75dnxa" />
        </a>

        <CTAButton className="mx-auto mt-3 max-w-lg" data-id="element-92" data-mp="30iazwxz9ckmf" />
        <TrustLine className="mt-3" data-id="element-93" data-mp="30ggfrlvt8wje" />
      </div>
    </section>;
}